import Transitions from './modules/transitions.js';
import Nav from './modules/nav.js';

function ready(fn)
{
	if(document.attachEvent ? document.readyState === "complete" : document.readyState !== "loading") {
    	fn();
  	} else {
    	document.addEventListener('DOMContentLoaded', fn);
	}
}
 
ready(init);

async function init()
{
	gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, CSSRulePlugin);

	initLenis();
	const transitions = new Transitions();	
	const nav = new Nav();	


	var haveHashUrlLoad = window.location.hash;
	if( haveHashUrlLoad ){
		console.log("YO");
		setTimeout(() => {
			gsap.to(window, {
				scrollTo: {
					y: haveHashUrlLoad,
					offsetY: 170 
				},
				duration: 0.5,
				ease: "power3.out"
			});
		}, 150);	
	}
	
	//window.addEventListener("resize", resizeHandler);
	//resizeHandler();
}

/**************************************************************	  
	
	Initialisation Lenis
	  
**************************************************************/	  	
let lenis;  
function initLenis()
{
	// Initialize a new Lenis instance for smooth scrolling
	lenis = new Lenis({
		duration: 1.2,
		easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
		direction: 'vertical',
		gestureDirection: 'vertical',
		smooth: true,
		smoothTouch: false,
		touchMultiplier: 2,
	});

	// Synchronize Lenis scrolling with GSAP's ScrollTrigger plugin
	lenis.on('scroll', ScrollTrigger.update);

	// Add Lenis's requestAnimationFrame (raf) method to GSAP's ticker
	// This ensures Lenis's smooth scroll animation updates on each GSAP tick
	gsap.ticker.add((time) => {
	lenis.raf(time * 1000); // Convert time from seconds to milliseconds
	});

	// Disable lag smoothing in GSAP to prevent any delay in scroll animations
	gsap.ticker.lagSmoothing(0);
}